class ComponentsAlBoSelectorController {

    constructor($element, $scope) {
        this.scope = $scope;
        this.selectedOptions = {};
        this.objectToActivate = null;
        this.activeObjects = [];
        this.optionAmounts = {};
        this.objectOptionToAdd = {};
        this.bookableObjects = this.bookableObjects || {};
        this.blockUpdate = false;
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.boModel;
        }, (newVal) => {
            this._transformInData(newVal);
        });

        this.scope.$watch(() => {
            return this.optionAmounts;
        }, (newVal) => {
            this.updateData();
        });

        this.scope.$watch(() => {
            return this.selectedOptions;
        }, (newVal) => {
            this.updateData();
        }, true);
    }

    _transformInData(data) {
        if (data) {
            const newData = {
                selected: {},
                amounts: {}
            };
            _.each(this.bookableObjects, (object) => {
                if (object.type === 'option_set' && data[object.uuid]) {
                    const objectUuid = object.uuid + '';
                    _.each(object.options, (option) => {
                        const optionUuid = option.uuid + '';

                        if (typeof data[objectUuid][optionUuid] !== 'undefined') {
                            if (!newData.selected[objectUuid]) {
                                newData.selected[objectUuid] = [];
                            }
                            if (newData.selected[objectUuid].indexOf(optionUuid) === -1) {
                                newData.selected[objectUuid].push(optionUuid);
                            }
                            switch (option.amount_type) {
                                case 'integer':
                                    newData.amounts[optionUuid] = parseInt(data[objectUuid][optionUuid]);
                                    break;
                                case 'float':
                                    newData.amounts[optionUuid] = parseFloat(data[objectUuid][optionUuid]);
                                    break;
                                case 'pax_based':
                                case 'always_one':
                                default:
                                    break;
                            }
                        }
                    });
                } else if ((object.type === 'day_range_bookings' || object.type === 'time_reserved') && data[object.uuid]) {
                    newData.selected[object.uuid] = _.cloneDeep(data[object.uuid]);
                }
            });

            if (!this._checkIfNewDataIsEqual(newData)) {
                this._updateInternalInformation(newData);
            }
        }
    }

    _checkIfNewDataIsEqual(newData) {
        return _.isEqual({
            selected: this.selectedOptions,
            amounts: this.optionAmounts
        }, newData);
    }

    _updateInternalInformation(newData) {
        this.selectedOptions = newData.selected;
        this.optionAmounts = newData.amounts;

        this.activeObjects = [];
        _.each(this.selectedOptions, (options, objectUuid) => {
            this.activeObjects.push(objectUuid);
        });
    }

    addSelectedToActive() {
        this.activeObjects.push(this.objectToActivate.uuid);
        this.objectToActivate = null;
    }

    removeActive(object) {
        const objectUuid = object.uuid + '',
            activeIndex = this.activeObjects.indexOf(objectUuid);
        if (activeIndex > -1) {
            this.activeObjects.splice(activeIndex, 1);
        }
        if (typeof this.selectedOptions[objectUuid] !== 'undefined') {
            delete this.selectedOptions[objectUuid];
        }

        this.updateData();
    }

    optionSelectionChange(value, boUuid) {
        boUuid = boUuid + '';
        let optionsNeedAmount = {},
            defaultAmount = 1;

        if (_.isArray(value)) {
            if (value.length > 0) {
                if (!_.isEqual(this.selectedOptions[boUuid], value)) {
                    this.selectedOptions[boUuid] = value;
                }
            } else if (this.selectedOptions[boUuid]) {
                delete this.selectedOptions[boUuid];
            }
        } else {
            if (value) {
                if (!_.isEqual(this.selectedOptions[boUuid], [value])) {
                    this.selectedOptions[boUuid] = [value];
                }
            } else if (this.selectedOptions[boUuid]) {
                delete this.selectedOptions[boUuid];
            }
        }

        _.each(this.bookableObjects, (object) => {
            const objectUuid = object.uuid;

            if (objectUuid === boUuid) {
                _.each(object.options, (option) => {
                    const optionUuid = option.uuid;

                    if (this.selectedOptions[boUuid].indexOf(optionUuid) > -1) {
                        switch (option.amount_type) {
                            case 'integer':
                            case 'float':
                                optionsNeedAmount[optionUuid] = true;
                                break;

                            default:
                                optionsNeedAmount[optionUuid] = false;
                                break;
                        }
                    }
                })
            }
        });

        _.each(optionsNeedAmount, (bool, optionUuid) => {
            if (!this.optionAmounts[optionUuid]) {
                this.optionAmounts[optionUuid] = defaultAmount;
            }
        });

        this.updateData();
    }

    updateData() {
        const preparedData = this.prepareDataForExternal();

        if (!_.isEqual(preparedData, this.boModel)) {
            this.onUpdate({newVal: preparedData});
        }
    }

    prepareDataForExternal() {
        const out = {};
        _.each(this.bookableObjects, (object) => {
            const objectUuid = object.uuid + '';
            if (object.type === 'option_set' && this.selectedOptions[objectUuid]) {
                out[objectUuid] = {};
                _.each(object.options, (option) => {
                    const optionUuid = option.uuid + '';
                    if (this.selectedOptions[objectUuid].indexOf(optionUuid) > -1) {
                        switch (option.amount_type) {
                            case 'integer':
                                if (this.optionAmounts[optionUuid]) {
                                    out[objectUuid][optionUuid] = parseInt(this.optionAmounts[optionUuid]);
                                }
                                break;
                            case 'float':
                                if (this.optionAmounts[optionUuid]) {
                                    out[objectUuid][optionUuid] = parseFloat(this.optionAmounts[optionUuid]);
                                }
                                break;
                            case 'pax_based':
                            case 'always_one':
                            default:
                                out[objectUuid][optionUuid] = true;
                                break;
                        }
                    }
                });
            } else if((object.type === 'day_range_bookings' || object.type === 'time_reserved') && this.selectedOptions[objectUuid]) {
                out[objectUuid] = this.selectedOptions[objectUuid];
            }
        });

        return out;
    }

    triggerUpdate() {
        this.updateData();
    }

    getOptionByUuid(objectUuid, optionUuid) {
        let out = null;
        _.each(this.bookableObjects, (object) => {
            if (object.uuid === objectUuid) {
                _.each(object.options, (option) => {
                    if (option.uuid === optionUuid) {
                        out = option;
                    }
                });
            }
        });

        return out;
    }

    addSelectedOptionToActive(objectUuid) {
        if (!this.selectedOptions[objectUuid]) {
            this.selectedOptions[objectUuid] = [];
        }

        this.selectedOptions[objectUuid].push({
            uuid: null,
            option_uuid: this.objectOptionToAdd[objectUuid].uuid,
            start_date: null,
            end_date: null
        });
        this.objectOptionToAdd[objectUuid] = null;
    }
}

ComponentsAlBoSelectorController
    .$inject = [
    '$element',
    '$scope',
];

/**
 * @ngdoc controller
 * @name components.components:ComponentsAlSwitchController
 * @restrict EA
 * @element
 *
 * @description
 *
 */
angular
    .module(
        'festzelt-os.components'
    )
    .controller(
        'ComponentsAlBoSelectorController',
        ComponentsAlBoSelectorController
    );



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/al-bo-selector/controller.js